import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './table.module.css';

type Props = {
  readonly url: string;
  readonly industryKbnName: string;
  readonly address: string;
  readonly phone: string;
  readonly presidentName: string;
  readonly ipoKbnName: string;
  readonly capital: string;
  readonly foundationDate: string;
};

/**
 * 企業情報を表示するテーブル
 * 空文字の値は "-" で表示する
 */
export function CompanyInformationTable({
  url,
  industryKbnName,
  address,
  phone,
  presidentName,
  ipoKbnName,
  capital,
  foundationDate,
}: Props) {
  return (
    <dl
      className={clsx(
        styles.container,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
    >
      <dt>URL</dt>
      <dd>
        {url === '' ? (
          '-'
        ) : (
          <a
            href={url}
            target='_blank'
            rel='noopener noreferrer nofollow'
            className={styles.link}
          >
            {url}
          </a>
        )}
      </dd>

      <dt>業種</dt>
      <dd>{industryKbnName || '-'}</dd>

      <dt>本社所在地</dt>
      <dd>{address || '-'}</dd>

      <dt>電話番号</dt>
      <dd>{phone || '-'}</dd>

      <dt>代表者名</dt>
      <dd>{presidentName || '-'}</dd>

      <dt>上場</dt>
      <dd>{ipoKbnName || '-'}</dd>

      <dt>資本金</dt>
      <dd>{capital || '-'}</dd>

      <dt>設立</dt>
      <dd>{foundationDate || '-'}</dd>
    </dl>
  );
}
